import React from "react";
import history from "../../services/history";
import { ButtonConfirm, CloseButton, Container, Content, Header, Subtitle, Title } from "./style";

export default function ReadyToGo(props) {
	const { title, body, button, route } = props.location.state;

	const goToLogin = () => {
		history.push(route);
	};

	return (
		<Container>
			<Content>
				<Header>
					<CloseButton onClick={goToLogin}></CloseButton>
				</Header>
				<Title>{title}</Title>
				<Subtitle>{body}</Subtitle>
				<ButtonConfirm onClick={goToLogin}>{button}</ButtonConfirm>
			</Content>
		</Container>
	);
}
